import { Icon, type IconType, Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from '@beacon/ui/components';
import { NavLink } from 'react-router';

interface SidebarNavLinkProps {
  to: string;
  icon: IconType;
  label: string;
  code: string;
  end?: boolean;
  collapsed?: boolean;
}

export function SidebarNavLink({ to, icon, label, code, end, collapsed }: SidebarNavLinkProps) {
  if (collapsed) {
    return (
      <div className="flex w-full justify-center">
        <NavLink to={to} end={end} aria-label={label} className="contents">
          {({ isActive }) => (
            <Tooltip>
              <TooltipTrigger asChild>
                <span
                  className={
                    isActive
                      ? 'border-l-primary-9 bg-surface-2 text-primary-9 grid h-[38px] w-[38px] place-items-center border-l-2'
                      : 'text-text-3 grid h-[38px] w-[38px] place-items-center rounded'
                  }
                >
                  <Icon symbol={icon} className="h-[17px] w-[17px] shrink-0" />
                </span>
              </TooltipTrigger>
              <TooltipPortal>
                <TooltipContent side="right" className="flex items-center gap-2">
                  {label}
                  <span className="text-ds-text-inverse/60 text-3xs font-mono">{code}</span>
                </TooltipContent>
              </TooltipPortal>
            </Tooltip>
          )}
        </NavLink>
      </div>
    );
  }

  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        [
          'text-md mb-0.5 flex items-center gap-2.5 border-l-2 px-2.5 py-2 no-underline transition-colors',
          isActive
            ? 'border-l-primary-9 bg-surface-2 text-text-1'
            : 'text-text-2 hover:bg-surface-2/50 hover:text-text-1 border-l-transparent',
        ].join(' ')
      }
    >
      {({ isActive }) => (
        <>
          <span className={['text-2xs font-mono', isActive ? 'text-primary-9' : 'text-text-3'].join(' ')}>{code}</span>
          <Icon symbol={icon} className={['h-3.5 w-3.5 shrink-0', isActive ? 'text-primary-9' : ''].join(' ')} />
          <span className={`flex-1 truncate ${isActive ? 'font-bold' : ''}`}>{label}</span>
        </>
      )}
    </NavLink>
  );
}
